
import { useEffect, useRef, useCallback, useMemo } from 'react';
import { useBoolean, useArray, useNumber, useStateful } from 'react-hanger';


const usePageInput = () => {
    useEffect(() => {
        if (typeof document !== 'undefined') {
            document.querySelector('html').classList.add('page-input');
            let height = document.documentElement.offsetHeight + 'px';
            // setTimeout(() => {
            let $page = document.querySelector('.page');
            $page.style.height = null
            $page.style.height = height;
            $page.dataset['height'] = height

            // }, 100)

        }

        return () => {
            if (typeof document !== 'undefined') {
                // document.querySelector('html').classList.remove('page-input');
                document.querySelector('.page').style.height = null
            }
        }
    }, [])
}

export default usePageInput;
